import { FC } from 'react';
import Link, { LinkProps } from '@o2/ui/Link';

export interface LinkDocProps extends LinkProps {
  /**
   * Document URL
   */
  url: string;
}

export const openFetchedDoc = (url: string) => {
  fetch(url)
    .then((response) => {
      return response.blob();
    })
    .then((blob) => {
      const objectURL = URL.createObjectURL(blob);

      window.open(objectURL);
      URL.revokeObjectURL(objectURL);
    })
    .catch((error) => {
      console.error(error);
    });
};

const LinkDoc: FC<LinkDocProps> = (props) => {
  const { children, url, ...otherProps } = props;

  return (
    <Link onClick={() => openFetchedDoc(url)} {...otherProps}>
      {children}
    </Link>
  );
};

LinkDoc.displayName = 'LinkDoc';

export default LinkDoc;
